module.exports = __webpack_public_path__ + "static/bystra-ee5ad6a1c73795b997dda36e3c2f21b1.png";